<template>
  <div class="px-3">
    <h2 class="h4 border-bottom border-2">メニュー</h2>
    <top-menu class="mb-4" :menus="menus" />
    <h2 class="h4 border-bottom border-2">お知らせ</h2>
    <notification-list class="notification-list overflow-auto mx-3" :notifications="notifications" />
  </div>
</template>

<script>
import {mapState} from "vuex";
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'
import TopMenu from '@/views/molecules/TopMenu'
import NotificationList from '@/views/molecules/NotificationList';

export default {
  name: "Top",
  components:{
    TopMenu,
    NotificationList,
  },
  mixins: [AddonLoadPageEvent],
  data() {
    return {
      menuList: [
        {routeName: 'AccountViewer', displayName: 'アカウント', icon: 'account'},
        {routeName: 'IssuanceRequestRegister', displayName: '発行依頼', icon: 'pencil'},
        {routeName: 'BrokerageCompanyViewer', displayName: '会社情報', icon: 'company'},
        {routeName: 'IssuanceRequestOwnList', displayName: '発行依頼履歴', icon: 'folder'},
        {routeName: 'OperationLogList', displayName: '操作ログ', icon: 'operation-log', isAdminOnly:true},
      ]
    };
  },
  computed: {
    ...mapState('top', {
      notifications: state => state.notifications,
    }),
    ...mapState('account', {
      isSuperVisor: state => state.is_supervisor,
    }),
    menus() {
      if(this.isSuperVisor) {
        return this.menuList;
      } else {
        return this.menuList.filter(menudata => !menudata.isAdminOnly);
      }
    },
  },
  methods: {
    loadPage() {
      return this.$store.dispatch('top/load').catch(() => this.$root.failApi());
    },
  }
}
</script>

<style scoped>
.notification-list {
  max-height: 25em;
}
</style>
